import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export const formatDate = (isoDate) => {
  // const formatted = new Intl.DateTimeFormat("en-GB", {
  //   weekday: "short",
  //   day: "2-digit",
  //   month: "short",
  //   year: "numeric",
  // }).format(d);

  const d = new Date(isoDate);
  return d.toLocaleDateString("en-GB", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // return formatted;
};

export const formatOnlyDate = (isoDate) => {
  const d = new Date(isoDate);
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }); // e.g. "30 Jul 2025"
};

export const formatTime = (timeStr) => {
  if (timeStr) {
    const [hour, minute] = timeStr?.split(":");
    const date = new Date();
    date.setHours(hour, minute);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }); // e.g. "03:30 PM"
  }
};

export function getAgeFromDob(dob) {
  if (!dob) return null;

  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  // Adjust if birthday hasn’t occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
}

export const formatDateProject = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  const options = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options);
  // e.g. "15 Aug 1995"
};

export function ProtectedRoute({ children, data }) {
  const { user } = useSelector((state) => state?.auth?.auth);
  const accessLevels = user?.access;

  // Special case: If user is admin, allow access to all modules
  const isAdmin = user?.role?.title === "admin" || user?.role?.title === "Admin";
  const hasAccess = !data?.module || isAdmin || accessLevels?.includes(data?.module);

  if (!hasAccess) {
    // Redirect invalid roles
    return <Navigate to={`/${accessLevels?.[0] || 'dashboard'}`} replace />;
  }
  return children;
}

// status -> color mapping
// export const getStatusColor = (status) => {
//   switch (status) {
//     case "New Project":
//       return "#9197B3"; // grey
//     case "Showcase":
//       return "#1E9A41"; // green
//     case "Not Accepted":
//       return "red";
//     case "-":
//       return "#9197B3"; // default grey
//     default:
//       return "orange"; // all other statuses
//   }
// };

export const getStatusStyles = (status) => {
  switch (status) {
    case "New Project":
      return {
        color: "#9197B3",
        background: "#F5F5F5",
        // border: "1px solid #9197B3",
      };
    case "Showcase":
      return {
        color: "#1E9A41",
        background: "#E9F7EF",
        // border: "1px solid #1E9A41",
      };
    case "Not Accepted":
      return {
        color: "red",
        background: "#FDECEC",
        // border: "1px solid red"
      };
    case "-":
      return {
        color: "#9197B3",
        background: "#F5F5F5",
        // border: "1px solid #9197B3",
      };
    default:
      return {
        color: "orange",
        background: "#FFF4E5",
        // border: "1px solid orange",
      };
  }
};

export const getStatusSelectStyles = (status) => {
  switch (status) {
    case "New Project":
      return {
        color: "#9197B3",
        border: "1px solid #9197B3",
      };
    case "Showcase":
      return {
        color: "#1E9A41",
        border: "1px solid #1E9A41",
      };
    case "Not Accepted":
      return { color: "red", border: "1px solid red" };
    default:
      return {
        color: "orange",
        border: "1px solid orange",
      };
  }
};

// App Feed status logic and styles
export const getAppFeedStatus = (postStartDate, postEndDate) => {
  const now = new Date();
  now.setHours(23, 59, 59, 999); // make 'now' the end of the current day

  const startDate = new Date(postStartDate);
  startDate.setHours(0, 0, 0, 0); // normalize to start of that day

  const endDate = new Date(postEndDate);
  endDate.setHours(23, 59, 59, 999); // normalize to end of that day

  if (endDate < now) {
    return "Expired";
  } else if (startDate > now) {
    return "Upcoming";
  } else {
    return "Active";
  }
};

export const getAppFeedStatusStyles = (status) => {
  switch (status) {
    case "Active":
      return {
        color: "#1E9A41", // Green
        background: "#E9F7EF",
        border: "1px solid #1E9A41",
      };
    case "Upcoming":
      return {
        color: "#E67E22", // Orange - readable on white background
        background: "#FEF9E7",
        border: "1px solid #E67E22",
      };
    case "Expired":
      return {
        color: "#BE282D", // Theme red
        background: "#FDECEC",
        border: "1px solid #BE282D",
      };
    default:
      return {
        color: "#9197B3",
        background: "#F5F5F5",
        border: "1px solid #9197B3",
      };
  }
};
